import { FunctionComponent, PropsWithChildren, ReactElement } from 'react';

import { Form, withFormik } from 'formik';
import compose from 'lodash/fp/compose';

import { withHigherOrderComponent } from '../../../../shared/components/with-higher-order-component/with-higher-order-component';
import { useNoSubmit } from '../../../../shared/hooks/use-no-submit/use-no-submit.hook';
import Filter from '../../../shared/components/filter/Filter';
import CategoriesDropdown from './components/categories-dropdown/categories-dropdown';
import FeaturedDropdown from './components/platforms-dropdown/featured-dropdown';
import PlatformsDropdown from './components/platforms-dropdown/platforms-dropdown';
import StatusDropdown from './components/status-dropdown';
import { AppFiltersFormikModel } from './models/app-filters-formik.model';
import { AppsFilterProps } from './types/apps-filter-props.type';

const AppsFilter: FunctionComponent<AppsFilterProps> = (
  props: PropsWithChildren<AppsFilterProps>
): ReactElement => {
  const { children, handleSubmit } = props;

  return (
    <Form onSubmit={handleSubmit}>
      <Filter>{children}</Filter>
    </Form>
  );
};

export default withFormik<Record<string, unknown>, AppFiltersFormikModel>({
  handleSubmit: useNoSubmit(),
})(
  compose(
    withHigherOrderComponent(CategoriesDropdown),
    withHigherOrderComponent(PlatformsDropdown),
    withHigherOrderComponent(StatusDropdown),
    withHigherOrderComponent(FeaturedDropdown)
  )(AppsFilter)
);
